export const calcularDuracion = (fechaInicio: Date, fechaFin: Date): string => {
    let años = fechaFin.getFullYear() - fechaInicio.getFullYear();
    let meses = fechaFin.getMonth() - fechaInicio.getMonth();
    let días = fechaFin.getDate() - fechaInicio.getDate();
  
    if (días < 0) {
      meses -= 1;
      const ultimoDiaMesAnterior = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), 0).getDate();
      días += ultimoDiaMesAnterior;
    }
  
    if (meses < 0) {
      años -= 1;
      meses += 12;
    }
  
    const partes: string[] = [];
    if (años > 0) partes.push(`${años} año${años > 1 ? 's' : ''}`);
    if (meses > 0) partes.push(`${meses} mes${meses > 1 ? 'es' : ''}`);
    if (días > 0) partes.push(`${días} día${días > 1 ? 's' : ''}`);
  
    return partes.join(' ');
  };
  

export const formatearFecha = (
    fecha: string | Date,
    opciones: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    }
  ): string => {
    try {
      const fechaObj = new Date(fecha);
      if (isNaN(fechaObj.getTime())) {
        throw new Error("Fecha inválida");
      }
      // Ajustar la fecha a la zona horaria local
      const fechaLocal = new Date(fechaObj.getTime() - fechaObj.getTimezoneOffset() * 60000);
      console.log(fechaLocal);
      // Formatear la fecha
      return fechaLocal.toLocaleTimeString("es-ES", opciones);
    } catch (error) {
      console.error("Error al formatear fecha:", error);
      return "Fecha inválida";
    }
  };
